import React, { useState } from "react"
import Modal from "react-bootstrap/Modal"
import "bootstrap/dist/css/bootstrap.min.css"
import Switch from "react-switch"
import { Offsymbol, OnSymbol } from "util/switchButtonUtil"
import { Col, Label, FormGroup } from "reactstrap"

import { AvForm, AvField } from "availity-reactstrap-validation"

const ApplicationForm = props => {
  const [status, setStatus] = useState(props?.app?.status || true)
  const _onSubmit = values => {
    const appData = { ...values, status }
    if (!appData.appId) {
      delete appData.appId
      props.onSave(appData, "create")
    } else {
      props.onSave(appData, "update")
    }
  }

  return (
    <>
      <Modal show={props.show} onHide={props.onClose} centered>
        <AvForm onValidSubmit={(e, values) => _onSubmit(values)}>
          <Modal.Header closeButton>
            <Modal.Title className="font-weight-semibold">
              {props.app ? "Edit" : "Create"} Application
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AvField
              name="appId"
              type="text"
              value={props?.app?.appId || ""}
              hidden
            />
            <FormGroup className="mb-4">
              <Label htmlFor="appName" className="font-weight-semibold">
                Full Name
              </Label>
              <AvField
                name="appName"
                type="text"
                errorMessage="Application Name is mandatory."
                value={props?.app?.appName || ""}
                required
              />
            </FormGroup>
            <FormGroup className="mb-4">
              <Label htmlFor="appCode" className="font-weight-semibold">
                Application Code
              </Label>
              <AvField
                style={{ textTransform: "uppercase" }}
                name="appCode"
                type="text"
                errorMessage="Application Code is mandatory."
                value={props?.app?.appCode || ""}
                disabled={props.app && props.app.appCode ? true : false}
                required
              />
            </FormGroup>
            <FormGroup className="mb-2">
              <Label htmlFor="status" className="font-weight-semibold">
                Status
              </Label>
              <Col lg="10">
                <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  className="me-1 mb-sm-8 mb-2"
                  onColor="#626ed4"
                  onChange={() => setStatus(!status)}
                  checked={status}
                />
              </Col>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-primary" type="submit">
              {props.app ? "Update" : "Create"}
            </button>
            <button className="btn btn-danger" onClick={props.onClose}>
              Cancel
            </button>
          </Modal.Footer>
        </AvForm>
      </Modal>
    </>
  )
}

export default ApplicationForm
